import React from "react";
import PageWrapper from "./category.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import AppointmentScheduleTable from "../../components/appointmentschedule/AppointmentScheduleTable";

const AppointmentSchedule = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.appointment_management"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.appointment_management"
          }
        ]}
      />
      <div className="user-tbl">
        <AppointmentScheduleTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.auth,
    ...state.themeChanger,
    ...state.permissionReducer,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(AppointmentSchedule);
